import { navigateToResolved } from '@innovyze/stylovyze/lib/actions';
import { useSelectNavigateTo } from '@innovyze/stylovyze/lib/selectors/navigate.selectors';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
export default function useNavigateTo() {
    const history = useHistory();
    const dispatch = useDispatch();
    const navigateTo = useSelectNavigateTo();
    React.useEffect(() => {
        if (navigateTo) {
            history.push(navigateTo);
            dispatch(navigateToResolved());
        }
    }, [navigateTo]);
}
